import { useTranslation } from 'react-i18next'
import { StyleSheet, ViewProps } from 'react-native'
import { useUsers } from 'zens-store'
import { PageHeaderProps } from 'zens-storybook'

import { LayoutHeader } from '../layout'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends PageHeaderProps {
  companyId: number
  search?: string
}

const UserListHeader = (props: Props) => {
  const { companyId, search, style, ...otherProps } = props
  const { t } = useTranslation()
  const users = useUsers({ companyId, search })
  return (
    <LayoutHeader
      style={[styles.container, style]}
      title={t('Users')}
      titleRight={users.data ? ` (${users.data?.length})` : ''}
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return <LayoutHeader.Skeleton style={[styles.container, style]} breadcrumb title {...otherProps} />
}
UserListHeader.Skeleton = Skeleton

export default UserListHeader
